import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  subscriberEmail: string = '';
  isSubmitting: boolean = false;
  subscribeMessage: string = '';
  isSuccess: boolean = false;

  private apiUrl = environment.apiUrl || 'http://localhost:3000';

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
  }

  subscribeNewsletter(): void {
    const email = (this.subscriberEmail || '').trim();
    if (!email || !email.includes('@')) {
      this.subscribeMessage = 'Ingresa un correo electrónico válido.';
      this.isSuccess = false;
      return;
    }

    this.isSubmitting = true;
    this.subscribeMessage = '';

    this.http.post<any>(`${this.apiUrl}/subscribers`, { email }).subscribe(
      (res) => {
        this.isSubmitting = false;
        this.isSuccess = true;
        this.subscribeMessage = res.message || '¡Gracias por suscribirte!';
        this.subscriberEmail = '';
        setTimeout(() => { this.subscribeMessage = ''; }, 6000);
      },
      (err) => {
        this.isSubmitting = false;
        this.isSuccess = false;
        this.subscribeMessage = err.error?.error?.message || 'Ocurrió un error al procesar la suscripción.';
        setTimeout(() => { this.subscribeMessage = ''; }, 6000);
      }
    );
  }
}
